import { render, staticRenderFns } from "./gradedafen.vue?vue&type=template&id=a4a5ba58&scoped=true&"
import script from "./gradedafen.vue?vue&type=script&lang=js&"
export * from "./gradedafen.vue?vue&type=script&lang=js&"
import style0 from "./gradedafen.vue?vue&type=style&index=0&id=a4a5ba58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a5ba58",
  null
  
)

export default component.exports